import $ from 'jquery';
window.$ = window.jQuery = $;

require('bootstrap');
require('jquery-lazy');
require('slick-carousel');

$(function() {
	$('.lazy').Lazy();
});

$(".product-slider").slick({
	lazyLoad: 'ondemand',
	prevArrow:'<div class="slider-nav slider-prev"><img src="/images/ui/prev.png" alt="Previous Slide" /></div>',
	nextArrow:'<div class="slider-nav slider-next"><img src="/images/ui/next.png" alt="Next Slide" /></div>'
});